import { Injectable } from '@angular/core';
import { DispatcherModule } from '../dispatcher.module';
import { NgRedux } from '@angular-redux/store';
import { AppState } from '../state.model';
import { FileActions } from './file-actions';

@Injectable({
  providedIn: DispatcherModule,
})
export class FileDispatcher {
  constructor(
    private ngRedux: NgRedux<AppState>
  ) { }

  /**
  * @method setUploadedFiledata sets the filedata which is uploaded
  * @param parsedData parsed object from the file
  **/
  setUploadedFiledata(parsedData: object) {
    this.ngRedux.dispatch(FileActions.setUploadedFiledata(parsedData));
  }
  /**
  * @method setFilename sets the file name
  * @param name name of file
  **/
  setFilename(name: string) {
    this.ngRedux.dispatch(FileActions.setFilename(name));
  }
  /**
  * @method setFiletype sets the file type
  * @param type type of file
  **/
  setFiletype(type: string) {
    this.ngRedux.dispatch(FileActions.setFiletype(type));
  }
  /**
  * @method submitFile sets if the filie is submitted or not
  * @param value boolean
  **/
  submitFile(value: boolean) {
    this.ngRedux.dispatch(FileActions.submitFile(value));
  }
  /**
  * @method setGeneration sets generation
  * @param generation string
  **/
  setGeneration(generation: string) {
    this.ngRedux.dispatch(FileActions.setGeneration(generation));
  }
  /**
  * @method setSupportedGeneration sets generation
  * @param generation string
  **/
  setSupportedGeneration(generation: Array<string>) {
    this.ngRedux.dispatch(FileActions.setSupportedGeneration(generation));
  }
  /**
  * @method setPackageGeneration sets generation
  * @param packageGeneration string
  **/
  setPackageGeneration(packageGeneration: string) {
    this.ngRedux.dispatch(FileActions.setPackageGeneration(packageGeneration));
  }
  /**
  * @method setProductGeneration sets generation
  * @param productGeneration string
  **/
  setProductGeneration(productGeneration: string) {
    this.ngRedux.dispatch(FileActions.setProductGeneration(productGeneration));
  }
  /**
  * @method setAsiGeneration sets generation
  * @param asiGeneration string
  **/
  setAsiGeneration(asiGeneration: string) {
    this.ngRedux.dispatch(FileActions.setAsiGeneration(asiGeneration));
  }
  /**
  * @method setAsiProductMapGeneration sets generation
  * @param generation string
  **/
  setAsiProductMapGeneration(generation: string) {
    this.ngRedux.dispatch(FileActions.setAsiProductMapGeneration(generation));
  }
  /**
  * @method setReviewApproved sets review approved
  * @param type type of file
  **/
  setReviewApproved(type: string) {
    this.ngRedux.dispatch(FileActions.setReviewApproved(type));
  }
}
